import { useQuery } from 'react-query';
import { getVendors } from '../../api/vendors';

/**
 * Look up a vendor ID by its stable key (e.g. "rolex").
 * Uses react-query cache so vendor list is fetched once per session.
 */
function useVendorByKey(key) {
  const { data: vendors, isLoading } = useQuery(
    'getVendors',
    () => getVendors({ params: { offset: 0, limit: 100, enabled: true } }),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      select: response => response?.data?.data || [],
    },
  );

  const vendor = (vendors || []).find(v => v?.key === key) || null;
  return { vendor, vendorId: vendor?.id || null, isLoading };
}

export default useVendorByKey;
